import { render, staticRenderFns } from "./GpNummern.vue?vue&type=template&id=2af55988&scoped=true&"
import script from "./GpNummern.vue?vue&type=script&lang=js&"
export * from "./GpNummern.vue?vue&type=script&lang=js&"
import style0 from "./GpNummern.vue?vue&type=style&index=0&id=2af55988&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af55988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VSpacer,VTooltip})
